<template>
    <div>
        <MultiPostingTabs/>
        <div class="bg-white rounded-4 rounded-tl-none shadow grow">
            <component
                class="m-24"
                ref="dynamicView"
                :is="selectedComponent"
                @change-tab="changeTab"
            />
        </div>
    </div>
</template>

<script>
import MultiPostingTabs from "../components/MultiPostingTabs.vue";
import Campaigns from "../views/Campaigns.vue";
import JobBoards from "../views/JobBoards.vue";
import Contracts from "../views/Contracts.vue";
import SocialBoosts from "../views/SocialBoosts.vue";
import {mapState, mapActions} from "pinia";
import {useMultiPostingStore} from '../state/modules/multiPosting';
import SelectDropdown from "../components/forms/SelectDropdown.vue";

export default {
    name: 'MultiPosting',
    components: {SelectDropdown, MultiPostingTabs, Campaigns, JobBoards, Contracts, SocialBoosts},
    computed: {
       ...mapState(useMultiPostingStore, ['selectedComponent', 'contractAuthState']),
    },
    methods: {
        ...mapActions(useMultiPostingStore, ['setCreatingCampaign', 'setSelectedComponent', 'setContractAuthState']),
        changeTab({tab, params}) {
            if (tab === 'Campaigns' && params === 'create') {
                this.setSelectedComponent(tab);
                this.setCreatingCampaign(true);
            }
        }
    },
    beforeMount() {
        if (this.$route.params.tab === 'contracts') {
            // most likely coming from share vacancy page - force contracts tab
            this.setSelectedComponent('Contracts');
        } else {
            const params = this.$route.query
            const state = params?.state ?? null
            const hash = params?.hash ?? null

            if (state && hash) {
                this.setContractAuthState({state: state, hash: hash})
                if (this.contractAuthState.valid) {
                    this.setSelectedComponent('Contracts');
                }
            } else {
                this.setSelectedComponent('Campaigns');
            }
        }
    }
}
</script>
